import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CheckboxEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { LEASE_DEALS_FILTERS } from 'site-modules/lease-deals/constants/lease-deals-constants';
import { CheckboxList } from 'site-modules/lease-deals/components/filters/ui/primitives/checkbox-list/checkbox-list';
import { PillCheckboxItem } from 'site-modules/lease-deals/components/filters/ui/primitives/pill-checkbox-item/pill-checkbox-item';

export const PillCheckboxControl = ({ options, dataKey, selectedValues = [], onChange, classNames = null }) => {
  const handleChange = useCallback(
    (newValues, value, checked) => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_TOOL_SELECT,
          subaction_name: checked ? 'apply_filter' : 'remove_filter',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          creative_id: LEASE_DEALS_FILTERS,
          value: `${dataKey}~${value}`,
        },
      });

      onChange(newValues);
    },
    [dataKey, onChange]
  );

  return (
    <CheckboxList
      options={options}
      onChange={handleChange}
      selectedValues={selectedValues}
      classNames={classNames}
      checkboxComponent={PillCheckboxItem}
    />
  );
};

PillCheckboxControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: CheckboxEntity.isRequired,
  dataKey: PropTypes.string.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  classNames: PropTypes.string,
};
